/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Persona_NoteInputs */



/**
* | output |
* | --- |
* | "If a persona contradicts one of your preferences, the persona wins." |
*
* @param {Memory_Persona_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_persona_note = /** @type {((inputs?: Memory_Persona_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Persona_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Widerspricht eine Persona einer deiner Präferenzen, gilt die Persona.")
	return /** @type {LocalizedString} */ ("If a persona contradicts one of your preferences, the persona wins.")
});